<template>
  <div id="app">
    <Header :bodyScrollBar="this.bodyScrollBar"/>
    <transition v-on:enter="enter" v-on:leave="leave">
      <router-view :bodyScrollBar="this.bodyScrollBar"/>
    </transition>
    <Footer :bodyScrollBar="this.bodyScrollBar"/>
  </div>
</template>

<style>

</style>

<script>

import Header from '@/components/structure/Header.vue'
import Footer from '@/components/structure/Footer.vue'

//import { SmoothMover }  from "@/common/smoothmover";
//import ModelViewer from '@/components/ModelViewer.vue'
//import Lottie from '@/components/Lottie.vue';
///import VideoThumbnail from '@/components/VideoThumbnail.vue';
//import GLTFViewer from '@/components/GLTFViewer.vue';
//import lottieData from '@/assets/pinjump.json';

import * as $ from 'jquery'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Scrollbar from 'smooth-scrollbar';

gsap.registerPlugin(ScrollTrigger);




export default {

  name: 'App',

  data() {
    return {
      bodyScrollBar: {},
      testname: "",
    };
  },

  
  
  components: {
    Header,
    Footer,
   // Lottie,
   // VideoThumbnail,
   // ModelViewer,
  },

  methods: {

 
    enter: function (el, done) {
      gsap.from(el, {opacity: "0", duration: 4, ease: "expo.out"})
      done();
    },

    leave: function (el, done) {
      gsap.to(el, {opacity: "0", duration: 4, ease: "expo.out"})
      done()
    },

    setHeaderPosition: ({ offset }) => {
        $("#header").css({"top": offset.y});
    }

  },



  beforeMount: function() {

  },

  updated: function() {

    console.log("Updated App");

  },
  mounted: function() {


    this.bodyScrollBar = Scrollbar.init(document.body, { damping: 0.1, delegateTo: document });
    this.testname = "Scott Gray";

    this.bodyScrollBar.addListener(this.setHeaderPosition);


    var _body 			= $('body');
    $("#menu-btn").click(function(e){
			e.preventDefault();
      if (_body.hasClass('menu--active')){
        _body.removeClass("menu--active");
        $('#menu-btn').find("span").text("Menu");
        $('#menu-btn').removeClass("is-active");
      } else {
        _body.addClass("menu--active");
        $('#menu-btn').find("span").text("Back");
        $('#menu-btn').addClass("is-active");
      }
    });
    
    $(".menu__items a").click(function(){
      //console.log("clicked menu2");
      if (_body.hasClass('menu--active')){
        _body.removeClass("menu--active");
      }
    });


  }

}
</script>